<div class="comment-container">
  <app-comment-card [comments]="comments" origin="campaign" [postCommentLabel]="'Write something to cheer '+fundraiser?.campaigner?.fname"
                    [campaignId]="fundraiser?.id" [customTag]="fundraiser?.custom_tag" >
  </app-comment-card>
</div>